import { Link, useLocation, useParams } from "react-router-dom";

const slugToTitle = (s = "") =>
  s.replace(/[-_]+/g, " ").replace(/\b\w/g, (m) => m.toUpperCase());


const BrandHeader = ({
  categoryNameFromApi,
  leftTitle = "Brand",
  productCount,
  backHref = "/product",
}) => {
  const location = useLocation();
  const params = useParams();

  const categoryName =
    (categoryNameFromApi && String(categoryNameFromApi)) ||
    (location?.state?.name && String(location.state.name)) ||
    (params?.slug ? slugToTitle(params.slug) : "Kategori");

  return (
    <header
      className="w-full sticky top-0 z-20 text-white bg-[#008277] shadow-sm"
    >
      <div className="max-w-screen-xl mx-auto px-4 py-4 md:py-5 flex items-center justify-between">
        <div className="flex items-center gap-3 md:gap-4">
          <h1 className="text-xl md:text-2xl font-semibold">{leftTitle}</h1>

          {typeof productCount === "number" && (
            <span
              className="hidden sm:inline-flex text-xs md:text-sm font-medium
                         px-2.5 py-1 rounded-full bg-white/15 backdrop-blur
                         border border-white/20"
            >
              {productCount} items
            </span>
          )}
        </div>

        <nav aria-label="Breadcrumb" className="text-sm">
          <ol className="flex items-center gap-2 text-white/80">
            <li>
              <Link to={backHref} className="hover:text-white">
                {leftTitle}
              </Link>
            </li>
            <li className="select-none" aria-hidden="true">
              /
            </li>
            <li className="text-white/90" aria-current="page">
              {categoryName}
            </li>
          </ol>
        </nav>
      </div>

      <div className="border-t border-white/10" />
    </header>
  );
};

export default BrandHeader;
